import { gql } from "@apollo/client";

export const GET_USER = gql`
  query getUser($id: String!) {
    user(id: $id) {
      id
      name
      username
      role
      phone
      email
      status
      place_id
      password
      imageURL
      address_city
      address_brgy
      address_details
    }
    __typename
  }
`;
